export function getSelectionContext(el: HTMLElement) {
  const path = getElementPath(el);
  const treeContext = getTreeContext(el);

  if (path.length > 0) {
    return `Component Hierarchy: ${path.join(' > ')}\n\nExtended Context: ${treeContext}`;
  }

  return treeContext;
}

function getElementPath(el: HTMLElement | null) {
  const path: string[] = [];

  while (el) {
    const attr = el.getAttribute('data-component');
    if (attr) {
      path.push(attr);
      el = el.parentElement ?? null;
    }

    // if the element itself matches, we get it back, and go up after pushing
    // or we go up now.
    el = el?.closest('[data-component]') ?? null;
  }

  return path.reverse();
}

function getTreeContext(el: HTMLElement | null, children = ''): string {
  if (!el) {
    return children;
  }

  if (el.getAttribute('data-banani-screenid')) {
    return children;
  }

  let postfix = ' ...';
  if (!children) {
    children = truncate(el.textContent, 50);

    postfix = '👈 selected element';
  }

  const siblingNum = [...(el.parentElement?.children ?? [])].indexOf(el);
  const siblings =
    !el.parentElement?.hasAttribute('data-banani-screenid') && siblingNum > 0
      ? `// ...\n`
      : '';

  let prefix = '';
  const comp = el.getAttribute('data-component');
  if (comp) {
    if (
      comp === '@global/Image.jsx' ||
      comp === '@globalComponents/Image.jsx'
    ) {
      return getTreeContext(
        el.parentElement,
        `${siblings}<Image${attr(el, 'data-query')} /> // ${comp}\n${postfix.replace('👈', '👆')}`,
      );
    }

    prefix += `<${comp.split('/').at(-1)?.split('.')[0]}> // ${comp};\n`;
  }

  let attrs = '';
  attrs += attr(el, 'id');
  attrs += attr(el, 'icon');
  attrs += attr(el, 'type');
  attrs += attr(el, 'data-query');
  attrs += attr(el, 'src');
  attrs += attr(el, 'class');

  let text =
    `<${el.tagName.toLowerCase()}${attrs} ${postfix}\n` + indent(children);

  if (el.hasAttribute('data-file') && el.tagName === 'SPAN') {
    text = `{t(${JSON.stringify(truncate(el.textContent, 50))})} // from ${el.getAttribute('data-file')}`;
  }

  return getTreeContext(
    el.parentElement,
    siblings + (prefix ? `${prefix}${indent(text)}` : text),
  );
}

function attr(el: HTMLElement, name: string, maxLength = 20) {
  const val = el.getAttribute(name);
  if (val) {
    return ` ${name}=${JSON.stringify(truncate(val, maxLength))}`;
  }

  return '';
}

function truncate(val: string, maxLength: number) {
  return val.length > maxLength ? `${val.substring(0, maxLength)}...` : val;
}

function indent(text: string) {
  return text
    .split('\n')
    .map((a) => `  ${a}`)
    .join('\n');
}
